
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import { formatPrice } from "@/utils/number";
import { cal } from "@/utils/cal";
import {piInfoShipmentRecords} from "@/api/proforma";

@Component({
  name: "ShippingRecord",
})
export default class extends Vue {
  formatPrice = formatPrice;

  @Prop({ default: false }) private show!: boolean;
  @Prop({ default: "history" }) private mode!: string;
  @Prop({ default: "" }) private customerCode!: string;
  @Prop({ default: "" }) private customerAbbreviation!: string;
  @Prop({ default: "" }) private numberType!: string;
  @Prop({ default: "" }) private number!: string;
  @Prop({ default: () => ({}) }) private record!: Record<string, any>;
  @Prop({ default: () => ({}) }) private query!: Record<string, any>;

  private loading = false;
  private table = {
    list: [] as any[],
  };

  get customerText() {
    const parts = [this.customerCode, this.customerAbbreviation].filter(Boolean);
    return parts.length ? parts.join(" ") : "-";
  }

  get piText() {
    return this.record.piCode || this.record.pi || "-";
  }

  get customerOrderQty() {
    if (this.record.shipmentQty != null && this.record.shipmentQty !== "") {
      return this.record.shipmentQty;
    }
    return this.record.customerOrderQty;
  }

  get currency() {
    const value = this.record.currency || "";
    if (value && typeof value === "object") {
      return (value as any).name || (value as any).code || (value as any).desc || "";
    }
    return value;
  }

  get salePriceText() {
    const price = this.record.saleDiscountPrice;
    if (price == null || price === "") {
      return "-";
    }
    const currency = this.currency || "-";
    return `${currency} ${formatPrice(Number(price))}`;
  }

  get totalAmountLabel() {
    return this.currency ? `合计 (${this.currency})` : "合计";
  }

  @Watch("show")
  private onShowChange(visible: boolean) {
    if (!visible) {
      return;
    }
    this.getList();
  }

  private close() {
    this.$emit("update:show", false);
  }

  private async getList() {
    this.loading = true;
    try {
      const res: any = await piInfoShipmentRecords(this.record.piInfoId);
      this.table.list = res || [];
    } catch (err) {
      console.log(err);
      this.table.list = [];
    } finally {
      this.loading = false;
    }
  }

  // TODO: 接口就绪后替换为真实请求
  private fetchShippingRecord(params: Record<string, any>) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          currency: "USD",
          list: [
            {
              id: "1",
              completedTime: "2026-02-03T10:00:00",
              documentType: "报关合同",
              documentCode: "BSC470G0010",
              quantity: 80,
            },
            {
              id: "2",
              completedTime: "2026-02-03T10:00:00",
              documentType: "报关计划",
              documentCode: "BSC470G0010",
              quantity: 32,
            },
            {
              id: "3",
              completedTime: "2026-02-03T10:00:00",
              documentType: "出库计划",
              documentCode: "BSC470G0010",
              quantity: 11,
            },
          ],
        });
      }, 300);
    });
  }

  private formatDate(value?: string) {
    if (!value) {
      return "-";
    }
    return moment(value).format("YYYY年MM月DD日");
  }

  private displayValue(value: any) {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    return value;
  }

  private sortByCompletedTimeDesc(list: any[]) {
    return list.slice().sort((a, b) => {
      const aTime = a && a.completedTime ? moment(a.completedTime).valueOf() : 0;
      const bTime = b && b.completedTime ? moment(b.completedTime).valueOf() : 0;
      return bTime - aTime;
    });
  }

  private formatDocumentType(documentType?: any) {
    if (documentType == null || documentType === "") {
      return "-";
    }
    if (typeof documentType === "object") {
      return documentType.desc || "-";
    }
    return String(documentType);
  }

  private documentTypeBadgeClass(documentType?: any) {
    const typeText = this.formatDocumentType(documentType);
    const classMap: Record<string, string> = {
      报关合同: "record-dialog__badge--customs-contract",
      报关计划: "record-dialog__badge--customs-plan",
      出库计划: "record-dialog__badge--outbound",
    };
    return classMap[typeText] || "record-dialog__badge--default";
  }

  private calcTotalAmount(row: any) {
    const price = this.record.saleDiscountPrice;
    const quantity = row.quantity;
    if (price == null || price === "" || quantity == null || quantity === "") {
      return null;
    }
    return Number(cal.cheng(Number(price), Number(quantity)));
  }

  private getShipmentDateLabel(documentType?: any) {
    const typeText = this.formatDocumentType(documentType);
    const labelMap: Record<string, string> = {
      报关合同: "确认报关信息日期",
      报关计划: "完成日期",
      出库计划: "出库日期",
    };
    return labelMap[typeText] || "";
  }

  private getMissingDateTooltipText(documentType?: any) {
    const typeText = this.formatDocumentType(documentType);
    const messageMap: Record<string, string> = {
      报关合同: "此【报关合同】的【确认报关信息】日期没有被记录，无法展示。",
      出库计划: "此【出库计划】的【出库】日期没有被记录，无法展示。",
      报关计划: "此【报关计划】的【出货】日期没有被记录，无法展示。",
    };
    return messageMap[typeText] || "";
  }

  private getDateTooltipText(row: any) {
    if (row.completedTime) {
      const label = this.getShipmentDateLabel(row.documentType);
      if (!label) {
        return "";
      }
      return `${label}: ${this.formatDate(row.completedTime)}`;
    }
    return this.getMissingDateTooltipText(row.documentType);
  }

  private hasDateTooltip(row: any) {
    return Boolean(this.getDateTooltipText(row));
  }
}
